import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { supSendMsgFun } from '../../../api/supportAdmin';

export const sendMessage = async (messageData, setLoading, setModal) => {
    setLoading(true);
    try {
        // if (messageData.msgType !== 'rate' && messageData.msgType !== 'whatsApp' && messageData.message.length < 10) {
        //     toast.error('The message must be more than 10 characters.');
        //     setLoading(false);
        // } else if (
        //     messageData.msgType !== 'rate' &&
        //     messageData.msgType !== 'whatsApp' &&
        //     messageData.message.length > 50
        // ) {
        //     toast.error('The message must be less than 50 characters.');
        //     setLoading(false);
        // } else {
        await supSendMsgFun(messageData);
        // .then((res) => {
        // if (res.status === 200) {
        toast.success('Message sent successfully');
        setModal(false);
        // } else {
        //     toast.error('Error sending message');
        // }
        setLoading(false);
        // });
        // }
    } catch (err) {
        setLoading(false);
        errorHandle(err);
    }
};
